export default __webpack_public_path__ + "static/media/mh.7a91998e.png";